export const resolveListQueryVariables = (variables = {}) => {
	const { extraFields } = variables || {};
	const baseVariables = { ...(variables || {}) };

	delete baseVariables.extraFields;
	delete baseVariables.listPaginationValue;

	if (!extraFields || Object.keys(extraFields).length === 0) {
		return baseVariables;
	}

	// Flatten extra fields for GraphQL while keeping list state structured.
	return {
		...extraFields,
		...baseVariables,
	};
};
